const MEDIA_DRAG_MIME_TYPE = "application/x-neozapp-message";
const MEDIA_DRAG_EVENT_START = "tickets:media-drag:start";
const MEDIA_DRAG_EVENT_END = "tickets:media-drag:end";
const MEDIA_DRAG_HANDLED_IN_APP = "tickets:media-drag:handled-in-app";

const MEDIA_LABEL_MAP = {
  image: "Imagem",
  video: "Vídeo",
  audio: "Áudio",
  application: "Documento",
};

const MEDIA_ICON_MAP = {
  image: "📷",
  video: "🎥",
  audio: "🎵",
  application: "📄",
  default: "📎",
};

const EXTENSION_MIME_MAP = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  mp4: "video/mp4",
  mov: "video/quicktime",
  avi: "video/x-msvideo",
  webm: "video/webm",
  mp3: "audio/mpeg",
  ogg: "audio/ogg",
  wav: "audio/wav",
  opus: "audio/opus",
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  doc: "application/msword",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  txt: "text/plain",
  zip: "application/zip",
  rar: "application/vnd.rar",
};

const resolveMediaType = (mediaType = "") => {
  const normalized = (mediaType || "").toLowerCase();
  if (normalized === "ptt" || normalized === "audio") {
    return "audio";
  }
  if (normalized === "document" || normalized === "application") {
    return "application";
  }
  if (normalized === "sticker" || normalized === "image") {
    return "image";
  }
  if (normalized === "video") {
    return "video";
  }
  return normalized || "application";
};

const extractExtensionFromUrl = (url = "") => {
  if (!url) return "";
  try {
    const cleanUrl = url.split("?")[0] || "";
    const segments = cleanUrl.split(".");
    if (segments.length <= 1) {
      return "";
    }
    return segments.pop().toLowerCase();
  } catch (err) {
    return "";
  }
};

const extractFileNameFromUrl = (url = "") => {
  if (!url) {
    return "";
  }
  try {
    const cleanUrl = url.split("?")[0] || "";
    const segments = cleanUrl.split("/");
    return decodeURIComponent(segments.pop() || "");
  } catch (err) {
    return "";
  }
};

const inferMimeType = (mediaType, mediaUrl = "") => {
  const extension = extractExtensionFromUrl(mediaUrl);
  if (extension && EXTENSION_MIME_MAP[extension]) {
    return EXTENSION_MIME_MAP[extension];
  }

  const normalizedType = resolveMediaType(mediaType);

  if (normalizedType === "image") {
    return "image/jpeg";
  }
  if (normalizedType === "video") {
    return "video/mp4";
  }
  if (normalizedType === "audio") {
    return "audio/mpeg";
  }

  return "application/octet-stream";
};

const getFileExtension = (fileName = "", mimeType = "") => {
  if (fileName) {
    const match = fileName.match(/\.[^.]+$/);
    if (match) {
      return match[0];
    }
  }

  if (mimeType) {
    const normalizedMime = mimeType.toLowerCase();
    const entry = Object.entries(EXTENSION_MIME_MAP).find(
      ([, value]) => value === normalizedMime
    );
    if (entry) {
      return `.${entry[0]}`;
    }
  }

  return "";
};

const getMediaLabel = (mediaType) => {
  const normalized = resolveMediaType(mediaType);
  return MEDIA_LABEL_MAP[normalized] || MEDIA_LABEL_MAP.application;
};

const getMediaIcon = (mediaType) => {
  const normalized = resolveMediaType(mediaType);
  return MEDIA_ICON_MAP[normalized] || MEDIA_ICON_MAP.default;
};

const shouldTriggerDeferredExternalDownload = (state = {}) => {
  const {
    prefetchComplete = false,
    dropConfirmed = false,
    handledInApp = false,
    canceled = false,
    downloadTriggered = false,
  } = state;

  return Boolean(
    prefetchComplete &&
    dropConfirmed &&
    !handledInApp &&
    !canceled &&
    !downloadTriggered
  );
};

export {
  MEDIA_DRAG_MIME_TYPE,
  MEDIA_DRAG_EVENT_START,
  MEDIA_DRAG_EVENT_END,
  MEDIA_DRAG_HANDLED_IN_APP,
  resolveMediaType,
  inferMimeType,
  extractFileNameFromUrl,
  getFileExtension,
  getMediaLabel,
  getMediaIcon,
  shouldTriggerDeferredExternalDownload,
  fetchMediaBlobSync
};

function fetchMediaBlobSync(url, token) {
  if (typeof XMLHttpRequest === "undefined" || !url) {
    return null;
  }

  try {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, false); // Synchronous request
    xhr.overrideMimeType("text/plain; charset=x-user-defined");
    xhr.setRequestHeader("Accept", "*/*");

    if (token) {
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    }

    xhr.send();

    if (xhr.status >= 200 && xhr.status < 400) {
      const responseText = xhr.responseText || "";
      const length = responseText.length;
      const buffer = new ArrayBuffer(length);
      const view = new Uint8Array(buffer);

      for (let i = 0; i < length; i += 1) {
        view[i] = responseText.charCodeAt(i) & 0xff;
      }

      return new Blob([buffer], { type: "application/octet-stream" });
    }

    console.warn("[mediaDrag] Fetch failed:", xhr.status);
    return null;
  } catch (error) {
    console.error("[mediaDrag] Fetch error:", error);
    return null;
  }
}
